import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=196b3db2"
import script from "./Refund.vue?vue&type=script&setup=true&lang=js"
export * from "./Refund.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Refund.vue?vue&type=style&index=0&id=196b3db2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports